var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5C6.64348 1.5 4.86301 2.2375 3.55025 3.55025C2.2375 4.86301 1.5 6.64348 1.5 8.5C1.5 10.3565 2.2375 12.137 3.55025 13.4497C4.86301 14.7625 6.64348 15.5 8.5 15.5C10.3565 15.5 12.137 14.7625 13.4497 13.4497C14.7625 12.137 15.5 10.3565 15.5 8.5C15.5 6.64348 14.7625 4.86301 13.4497 3.55025C12.137 2.2375 10.3565 1.5 8.5 1.5ZM9.5 12.5H7.5V10.5H9.5V12.5ZM9.5 9.5H7.5V3.5H9.5V9.5Z",
    fill: "#FFA200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRound);
export default __webpack_public_path__ + "static/media/warning_round.70ea1bf77967af42164b04af7d46faea.svg";
export { ForwardRef as ReactComponent };